<template>
    <v-row>
        <Loader v-if="loader"></Loader>
        <v-col cols="12">
            <v-card flat>
                <v-card-text>
                    <v-col class="mx-auto" cols="12" md="8">
                        <v-form ref="form" v-on:submit.prevent="saveContact">
                            <v-row>
                                <v-col cols="12"><h4>دفتر تهران</h4></v-col>
                                <v-col cols="12">
                                    <v-textarea v-model="tehranAddress" outlined dense rows="2" label="آدرس تهران" />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="tehranPhone" outlined dense label="تلفن تهران" />
                                </v-col>

                                <v-col cols="12"><h4>دفتر شیراز</h4></v-col>
                                <v-col cols="12">
                                    <v-textarea v-model="shirazAddress" outlined dense rows="2" label="آدرس شیراز" />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="shirazPhone" outlined dense label="تلفن شیراز" />
                                </v-col>

                                <v-col cols="12"><h4>مزرعه / فارس</h4></v-col>
                                <v-col cols="12">
                                    <v-textarea v-model="farmAddress" outlined dense rows="2" label="آدرس مزرعه" />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="farmPhone" outlined dense label="تلفن مزرعه" />
                                </v-col>

                                <v-col cols="12"><h4>ارتباط عمومی</h4></v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="email" outlined dense label="ایمیل" />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="instagram" outlined dense
                                        label="لینک اینستاگرام (اختیاری)" hint="در صورت خالی بودن در سایت نمایش داده نمی‌شود" persistent-hint />
                                </v-col>

                                <v-col cols="12">
                                    <v-btn width="100%" height="40" class="white--text" depressed color="#02c9b7" type="submit">
                                        ذخیره
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-col>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        data() {
            return {
                loader: false,
                tehranAddress: '',
                tehranPhone: '',
                shirazAddress: '',
                shirazPhone: '',
                farmAddress: '',
                farmPhone: '',
                email: '',
                instagram: '',
            }
        },
        created() {
            this.loadContact()
        },
        methods: {
            loadContact() {
                this.loader = true
                this.request({ method: 'get', url: '/admin/contact' })
                    .then((response) => {
                        const d = response.data
                        this.tehranAddress = d.tehranAddress
                        this.tehranPhone = d.tehranPhone
                        this.shirazAddress = d.shirazAddress
                        this.shirazPhone = d.shirazPhone
                        this.farmAddress = d.farmAddress
                        this.farmPhone = d.farmPhone
                        this.email = d.email
                        this.instagram = d.instagram || ''
                    })
                    .finally(() => {
                        this.loader = false
                    })
            },
            saveContact() {
                this.loader = true
                this.request({
                    method: 'put',
                    url: '/admin/contact',
                    data: {
                        tehranAddress: this.tehranAddress,
                        tehranPhone: this.tehranPhone,
                        shirazAddress: this.shirazAddress,
                        shirazPhone: this.shirazPhone,
                        farmAddress: this.farmAddress,
                        farmPhone: this.farmPhone,
                        email: this.email,
                        instagram: this.instagram,
                    }
                })
                .then(() => {
                    this.$notify({
                        title: 'انجام شد',
                        text: 'اطلاعات تماس ذخیره شد',
                        group: 'foo',
                        type: 'success',
                    });
                })
                .finally(() => {
                    this.loader = false
                })
            },
        }
    }
</script>
